import { lazy } from 'react'

const dashboardLazy = lazy(() =>
  import(/* webpackChunkName: "Dashboard" */ './dashboard'),
)

export default dashboardLazy
